import { useEffect, useState } from "react";
import api, { fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { StatCard } from "@/components/shared/StatCard";
import { Store, CheckCircle, PauseCircle, ShoppingCart, Users, TrendingUp } from "lucide-react";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

export default function CentralDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/central/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-400">Chargement…</div>;

  return (
    <div>
      <PageHeader title="Tableau de bord" subtitle="Vue d'ensemble de la plateforme Vision POS" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Boutiques" value={d.total_stores} icon={Store} testid="admin-metrics-total-stores" />
        <StatCard label="Actives" value={d.active_stores} icon={CheckCircle} hint="Abonnements actifs" />
        <StatCard label="Suspendues" value={d.suspended_stores} icon={PauseCircle} />
        <StatCard label="CA plateforme" value={fmtMoney(d.platform_revenue)} icon={TrendingUp} testid="admin-metrics-total-revenue" />
        <StatCard label="Commandes" value={d.orders} icon={ShoppingCart} />
        <StatCard label="Prospects" value={d.prospects} icon={Users} />
        <StatCard label="Abonnements" value={d.active_subscriptions} icon={CheckCircle} />
        <StatCard label="Expirations proches" value={d.expiring_soon} icon={PauseCircle} />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="vp-card rounded-xl p-6 lg:col-span-2">
          <h3 className="text-lg font-semibold text-white mb-4">Chiffre d'affaires plateforme</h3>
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={d.chart}>
              <defs><linearGradient id="rev" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#3DBB2C" stopOpacity={0.4} /><stop offset="95%" stopColor="#3DBB2C" stopOpacity={0} /></linearGradient></defs>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
              <XAxis dataKey="month" stroke="#64748b" fontSize={12} />
              <YAxis stroke="#64748b" fontSize={12} />
              <Tooltip contentStyle={{ background: "#14161D", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "#fff" }} />
              <Area type="monotone" dataKey="revenue" stroke="#3DBB2C" strokeWidth={2} fill="url(#rev)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div className="vp-card rounded-xl p-6">
          <h3 className="text-lg font-semibold text-white mb-4">Activité récente</h3>
          <div className="space-y-3">
            {(d.recent_activity || []).slice(0, 8).map((a) => (
              <div key={a.id} className="flex items-start gap-3 text-sm">
                <div className="h-2 w-2 rounded-full vp-accent-bg mt-1.5 shrink-0" />
                <div><div className="text-slate-200">{a.action} · {a.entity} {a.detail && `— ${a.detail}`}</div><div className="text-xs text-slate-500">{a.user} · {fmtDate(a.created_at)}</div></div>
              </div>
            ))}
            {(!d.recent_activity || d.recent_activity.length === 0) && <p className="text-sm text-slate-500">Aucune activité</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
